import type { Common } from '@libs/domain';
import { TextStringField } from '@ps-smart-cp/ppfw-client';
import { locationMstListSearchFieldConfig } from '../item-config';

function AdditionalInfo<T extends Pick<Common['schema'], 'address'>>(
  mst: T,
  setMst: (t: T) => void,
  errorFields?: string[],
) {
  return (
    <TextStringField
      items={locationMstListSearchFieldConfig}
      obj={mst}
      setObj={setMst}
      prop="address"
      errorFields={errorFields}
    />
  );
}

export { AdditionalInfo };
